import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useMaps = () => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  const { getRoute } = useWexClient();

  const handleRequest = async (callback, defaultMessage) => {
    setLoader(true);
    setError(null);

    try {
      return await callback();
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || defaultMessage;

      setError(message);

      return {
        success: false,
        message,
      };
    } finally {
      setLoader(false);
    }
  };

  const getRouteByPoints = async (body = {}) => {
    return handleRequest(
      () => getRoute(body),
      "Error al obtener la ruta",
    );
  };

  return {
    getRouteByPoints,
    loader,
    error,
  };
};

export default useMaps;